import { useEffect } from 'react';

/**
 * 监听 & 移除监听 dom 事件
 * @param eventName 事件名
 * @param handle
 * @param condition 监听条件
 * @param target
 * @param depends
 */
export const useEventListener = (
    eventName: string,
    handle: (e: Event) => void,
    condition = true,
    target: Document | HTMLElement = document,
    depends: any[] = [],
) => {
    useEffect(() => {
        if (condition) {
            target.addEventListener(eventName, handle);
        }
        return () => {
            target.removeEventListener(eventName, handle);
        };
    }, depends);
};
